import { useTranslation } from "react-i18next";
import css from "./index.module.css";

function LicenceWarning() {
  const { t } = useTranslation();
  return (
    <div className={css.root}>
      {t("Licensing error. Please contact your administrator or try accessing the application after some time.")}
    </div>
  );
}

export default LicenceWarning;
